module.exports = __webpack_public_path__ + "img/rubik-bold-webfont.cd42fc5c.cd42fc5c.svg";